import React, { useState, useEffect } from 'react';
import { useSession } from '../../context/SessionContext';
import { CountdownTimer, ProgressBar } from './';

function StickyMenu({ timerMinutes, startDate, timerDuration, onTimeUp }) {
  const { sessionData } = useSession();
  const countdown_enabled = sessionData?.countdown_enabled ?? true; // Default to true if not available
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Handle scroll events
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show menu when scrolling up, hide when scrolling down
      if (currentScrollY < lastScrollY) {
        setVisible(true);
      } else if (currentScrollY > 50 && currentScrollY > lastScrollY) {
        setVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <div 
      className={`fixed top-0 left-0 right-0 bg-white shadow-md z-50 p-3 transition-transform duration-300 ${
        visible ? 'transform-none' : '-translate-y-full'
      }`}
    >
      <div className="container mx-auto">
        <div className="flex items-center">
          {/* Left: Logo (only shown if available) */}
          {sessionData?.logo && (
            <>
              <div className="flex-shrink-0 mr-4">
                <img 
                  src={sessionData.logo} 
                  alt={`${sessionData?.company || 'Company'} logo`} 
                  className="h-8 w-auto object-contain" 
                />
              </div>
              
              {/* Separator (only shown if logo is available) */}
              <div className="h-8 border-l border-gray-300 mr-4"></div>
            </>
          )}
          
          {/* Job Title */}
          <div className="font-semibold text-lg">
            {sessionData?.job || "Evaluation"}
          </div>
          
          {/* Spacer to push progress bar and timer to the right */}
          <div className="flex-grow"></div>
          
          {/* Progress Bar - with appropriate width */}
          <div className="mx-4 max-w-lg">
            <ProgressBar />
          </div>

          {/* Separator and Timer - only show when countdown is enabled */}
          {countdown_enabled && (
            <>
              {/* Separator */}
              <div className="h-8 border-l border-gray-300 ml-4 mr-4"></div>
              
              {/* Timer */}
              <div className="flex-shrink-0 ml-4">
                {(timerMinutes || (startDate && timerDuration)) ? (
                  <CountdownTimer 
                    initialMinutes={timerMinutes} 
                    startDate={startDate}
                    timerDuration={timerDuration}
                    onTimeUp={onTimeUp || (() => {})} 
                  />
                ) : null}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default StickyMenu;
